module.exports = __webpack_public_path__ + "static/img/reservoir1.d5984c86.jpeg";